import { ls } from '@/utility';

export default {
  user: ls.user.get(),
};
